export default "__VITE_ASSET__c802f2e4__"